import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

// import { AddressByZipCodeInterface } from '../../../main/modules/register/services/services-form/services-form.component';

@Injectable()
export class LocationService implements OnDestroy {
  constructor(private _httpClient: HttpClient) {}

  ngOnDestroy(): void {}

  async getAddressByZipCode(zipCode: string): Promise<any> {
    const END_POINT: string = 'autenticacao';

    const url = `https://viacep.com.br/ws/${zipCode}/json/`;
    return await firstValueFrom(this._httpClient.get<any>(url));
  }
}
